import React from 'react';

/**
 * @internal Не для публичного использования
 */
const DrawerContext = React.createContext(undefined);
/**
 * @internal Не для публичного использования
 */
const useDrawerContext = () => React.useContext(DrawerContext);

export { DrawerContext, useDrawerContext };
